var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgStartsiteCard3 = function SvgStartsiteCard3(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 428,
    viewBox: "0 0 373 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_12263)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 428,
    fill: "#F2EADF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 373,
    height: 428,
    fill: "url(#paint0_linear_1316_12263)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M0 429.5V54.5C0 54.5 119 253 372.5 268.5V429.5H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 157V0H63C140.78 112.041 373 157 373 157Z",
    fill: "#EDE3D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1316_12263",
    x1: 186.5,
    y1: 0,
    x2: 186.5,
    y2: 428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3B996",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B996"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_12263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 428,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgStartsiteCard3);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";